import * as React from "react";
import { GenomeInList } from "../../api";
import { Icon } from "@blueprintjs/core";
import { observer } from "mobx-react";

const FavoriteStar = observer(
  ({
    userLoggedIn,
    genome,
    toggleStarring,
  }: {
    userLoggedIn: boolean;
    genome: GenomeInList;
    toggleStarring: (starred: boolean, uuid: string) => void;
  }) => {
    if (!userLoggedIn) {
      return null;
    }
    return (
      <Icon
        className={`genome-star ${genome.starred ? "filled" : ""}`}
        icon={genome.starred ? "star" : "star-empty"}
        onClick={() => toggleStarring(!genome.starred, genome.uuid)}
      />
    );
  }
);

export default FavoriteStar;
